'use es6';

import * as Operators from '../operator/Operators';
import { OrderedSet } from 'immutable';
import DisplayValueTeam from 'customer-data-filters/components/display/DisplayValueTeam';
import FilterOperatorTeamInput from 'customer-data-filters/components/operator/FilterOperatorTeamInput';
export default {
  hubspot_team_id: {
    InputComponent: FilterOperatorTeamInput,
    ValueComponent: DisplayValueTeam,
    referencedObjectType: 'TEAM'
  },
  hs_all_accessible_team_ids: {
    operators: OrderedSet.of(Operators.ContainAllTeams),
    InputComponent: FilterOperatorTeamInput,
    ValueComponent: DisplayValueTeam
  }
};